import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { ReporteCantidadesComponent } from './reporte-cantidades/reporte-cantidades.component';
import { ReporteUACComponent } from './reporte-UAC.component';
import { ReporteUACRouting } from './reporte-UAC-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReporteDetalleAtencionesComponent } from './reporte-detalle-atenciones/reporte-detalle-atenciones.component';
import { ReporteDetalleAbandonadosComponent } from './reporte-detalle-abandonados/reporte-detalle-abandonados.component';
import { AgendamientoTurnoVirtualUACComponent } from './agendamiento-turno-virtual-UAC/agendamiento-turno-virtual-UAC.component';




export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}
@NgModule({
  declarations: [
    ReporteUACComponent,
    ReporteCantidadesComponent,
    ReporteDetalleAtencionesComponent,
    ReporteDetalleAbandonadosComponent,
    AgendamientoTurnoVirtualUACComponent
  ],
  imports: [
    ReporteUACRouting,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: []
})
export class ReporteUACModule { }
